import {combineOnKey, reducer} from './helpers'
import {
  CALCULATE_FAILURE,
  CALCULATE_PENDING,
  CALCULATE_SUCCESS,
  CANCEL_SIZES,
  DISPLAY_ERROR,
  DISPLAY_INFO,
  EDIT_SIZES,
  HIDE_ERROR,
  HIDE_INFO,
  RECORD_SIZE_INPUT,
  RECORD_STEP_INPUT,
  RECORD_STEP_RESPONSE,
  RECORD_SURVEY_INPUT_VALIDATION_FAILURE,
  SET_CURR_STEP,
  SET_ON_DECK_STEP,
} from '../actions/fit'
import {GET_FIT_PROFILE_SUCCESS} from '../actions/fitProfile'
import {SET_SIZES_SUCCESS} from '../actions/sizes'
import {DEFAULT_FIT_FLOW} from '../components/Fit/enums'
import {isFilledString} from '../utils'

const initialState = {
  flow: DEFAULT_FIT_FLOW,
}

const filledStringOrUndefined = (value) => (isFilledString(value) ? value : undefined)

export default reducer(initialState, (state, {payload, type}) => {
  switch (type) {
    case CALCULATE_FAILURE:
      return combineOnKey('calculate', state, {
        data: payload,
        error: true,
        status: 'FAILURE',
      })
    case CALCULATE_PENDING:
      return combineOnKey('calculate', state, {
        error: false,
        status: 'PENDING',
      })
    case CALCULATE_SUCCESS:
      return combineOnKey('calculate', state, {
        error: false,
        status: 'SUCCESS',
        thereWasASuccessfulCalculationDuringThisSession: true,
      })
    case CANCEL_SIZES:
      return {
        isEditing: null,
        sizeInputsById: null,
      }
    case EDIT_SIZES:
      return {
        isEditing: payload,
        sizeInputsById: null,
      }
    case DISPLAY_ERROR:
      return {
        error: payload,
        errorIsVisible: true,
      }
    case DISPLAY_INFO:
      return {
        info: payload,
        infoIsVisible: true,
      }
    case HIDE_ERROR:
      return {
        errorIsVisible: false,
      }
    case HIDE_INFO:
      return {
        infoIsVisible: false,
      }
    case RECORD_SIZE_INPUT:
      return {
        sizeInputsById: {
          ...state.sizeInputsById,
          [payload.id]: filledStringOrUndefined(payload.value),
        },
      }
    case RECORD_STEP_INPUT:
      return {
        stepInputsById: {
          ...state.stepInputsById,
          [payload.id]: filledStringOrUndefined(payload.value),
        },
        surveyInputFailure: undefined,
      }
    case RECORD_STEP_RESPONSE:
      return {
        stepIsSkippedById: {
          ...state.stepIsSkippedById,
          [payload.id]: !isFilledString(payload.value), // the user clicked SKIP
        },
        stepResponsesById: {
          ...state.stepResponsesById,
          [payload.id]: filledStringOrUndefined(payload.value),
        },
        surveyInputFailure: undefined,
      }
    case RECORD_SURVEY_INPUT_VALIDATION_FAILURE:
      return {
        surveyInputFailure: payload,
      }
    case SET_CURR_STEP:
      return {
        oldStepSlug: state.currStepSlug,
        currStepSlug: payload,
        stepInputsById: state.stepResponsesById,
        surveyInputFailure: undefined,
      }
    case SET_ON_DECK_STEP:
      return {
        isEditing: null,
        onDeckStepSlug: payload,
      }
    case GET_FIT_PROFILE_SUCCESS:
      return {
        stepResponsesById: {
          ...state.stepResponsesById,
          ...payload,
        },
      }
    case SET_SIZES_SUCCESS:
      return {
        isEditing: null,
        sizeInputsById: null,
      }
    default:
      return null
  }
})
